import { __ } from '@wordpress/i18n';
import { useContext } from 'preact/hooks';

import { AppContext } from '../../context/AppContext';
import { toTitleCase } from '../../helpers/toTitleCase';
import { CloseIcon } from '../icons/icons';

export default function SelectedPrograms() {
	const { filterContext } = useContext( AppContext );
	const [ filterState, dispatch ] = filterContext;
	const programs = filterState.programs;

	return (
		<div className="tcc-map__selected-programs-wrap">
			{programs.length > 0 && (
				<div className="tcc-map__selected-programs">
					{programs.map( ( program, index ) => (
							<button
								key={ index }
								type="button"
								className="tcc-map__selected-program link-level-2"
								aria-label={ __( 'Remove program', 'tcc-map' ) . concat( ` ${toTitleCase(program)}` ) }
								onClick={ () => {
									const nextPrograms = programs.filter( ( p ) => ( p !== program ) );
									dispatch( { type: 'SET_PROGRAMS', payload: nextPrograms } );
								} }
							>
								<span className="tcc-map__selected-program-text">
									{ toTitleCase(program) }
								</span>
								<CloseIcon />			
							</button>
					) ) }
				</div>
			) }
		</div>
	);
}
